export const configs = {
    includePages: ['/vanlife-roadtrips', '/whole-home-backup-power-solution', '/delta-pro-ultra', '/on-the-road-power-solution'],
    includeSites: ['us'],
    times: {
        us: { start: '2024/11/04 00:00:00 GMT+8', end: '2024/12/03 00:00:00 GMT+8' },
    },
};
